(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('ValuationApiClientDialogController', ValuationApiClientDialogController);

    ValuationApiClientDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ValuationApiClient'];

    function ValuationApiClientDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ValuationApiClient) {
        var vm = this;

        vm.valuationApiClient = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;

            if (vm.valuationApiClient.id !== null) {
                ValuationApiClient.update(vm.valuationApiClient, onSaveSuccess, onSaveError);
            } else {
                ValuationApiClient.save(vm.valuationApiClient, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('valueconnectApp:valuationApiClientUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();
